import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=5fc606a1&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5fc606a1')) {
      api.createRecord('5fc606a1', component.options)
    } else {
      api.reload('5fc606a1', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=5fc606a1&", function () {
      api.rerender('5fc606a1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-229E3io7NnGl6/JS/comp/openstreetmap.vue"
export default component.exports